import { render, staticRenderFns } from "./modalRegraPosVenda.vue?vue&type=template&id=35ee4c72&scoped=true"
import script from "./modalRegraPosVenda.vue?vue&type=script&lang=js"
export * from "./modalRegraPosVenda.vue?vue&type=script&lang=js"
import style0 from "./modalRegraPosVenda.vue?vue&type=style&index=0&id=35ee4c72&prod&scoped=true&lang=css"
import style1 from "./modalRegraPosVenda.vue?vue&type=style&index=1&id=35ee4c72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ee4c72",
  null
  
)

export default component.exports